var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsbLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 32,
    viewBox: "0 0 134 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1578 24.7476C36.1578 22.9943 35.5178 21.4004 34.4778 20.1252L19.6785 2.59182C18.3985 0.997871 16.3986 0.0415039 14.1587 0.0415039C10.2388 0.0415039 6.95898 3.22939 6.95898 7.21426C6.95898 8.9676 7.59896 10.5615 8.63892 11.8367L23.4383 29.4498C24.7182 31.0437 26.7182 32.0001 28.9581 32.0001C32.9579 31.9204 36.1578 28.7325 36.1578 24.7476Z",
    fill: "url(#paint0_radial_1369_8540)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3594 30.406C34.7194 29.3699 35.6794 27.8557 35.9994 26.2618L39.9194 8.80806C40.3994 6.81562 39.9994 4.5841 38.6394 2.83076C36.2394 -0.357129 31.7594 -0.91501 28.5594 1.47591C27.1994 2.51197 26.2395 4.02622 25.9195 5.62016L22.0795 22.6754L21.9995 23.1536C21.5195 25.146 21.9195 27.3775 23.2795 29.1309C25.6795 32.239 30.2394 32.8766 33.3594 30.406Z",
    fill: "url(#paint1_radial_1369_8540)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9585 24.7476C54.9585 22.9943 54.3185 21.4004 53.2785 20.1252L38.3992 2.59182C37.1192 0.997871 35.1193 0.0415039 32.8794 0.0415039C28.9596 0.0415039 25.6797 3.22939 25.6797 7.21426C25.6797 8.9676 26.3197 10.5615 27.3596 11.8367L42.159 29.4498C43.439 31.0437 45.4389 32.0001 47.6788 32.0001C51.7586 31.9204 54.9585 28.7325 54.9585 24.7476Z",
    fill: "url(#paint2_radial_1369_8540)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19999 31.9202C11.1764 31.9202 14.4 28.7089 14.4 24.7475C14.4 20.7861 11.1764 17.5747 7.19999 17.5747C3.22354 17.5747 0 20.7861 0 24.7475C0 28.7089 3.22354 31.9202 7.19999 31.9202Z",
    fill: "url(#paint3_radial_1369_8540)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.436 15.4231L131.276 15.2637L131.436 15.1043C132.556 13.7494 133.116 12.0758 133.036 10.3224C132.876 6.33758 129.276 3.30908 124.876 3.30908H115.437C113.837 3.30908 112.637 4.58424 112.637 6.09849V26.0228C112.637 27.6167 113.917 28.8122 115.437 28.8122H124.796C127.116 28.8122 129.276 28.0152 130.956 26.501C132.636 24.9867 133.596 22.9943 133.596 20.8425C133.676 18.7703 132.876 16.8576 131.436 15.4231ZM118.156 8.33001H125.276C126.636 8.33001 127.516 9.52547 127.516 10.5615C127.516 11.9164 126.316 12.7931 125.276 12.7931H118.156V8.33001ZM125.356 23.6319H118.156V17.8937H125.276C126.396 17.8937 128.156 18.6907 128.156 20.8425C128.156 22.0379 127.196 23.6319 125.356 23.6319Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.276 13.4306C99.1163 12.8727 96.5563 12.1555 96.3963 10.4021C96.3163 9.20667 97.2763 8.1706 98.8763 7.93151C102.076 7.53303 104.876 9.36606 106.396 9.76455C107.916 10.163 109.116 8.88788 109.276 7.61272C109.516 5.69999 107.596 4.66392 106.876 4.18574C105.676 3.46847 103.516 2.5918 100.316 2.5918C94.6363 2.5918 90.7163 5.85938 90.7163 10.4818C90.7163 13.0321 91.6763 14.8652 93.5163 16.22C97.1163 18.9297 104.156 18.6109 104.156 21.4003C104.156 23.871 99.5163 25.4649 94.3963 22.1176C93.9163 21.7988 93.4363 21.5597 92.7963 21.5597C91.4363 21.5597 90.2363 22.6755 90.2363 24.1101C90.2363 24.5882 90.3163 24.9867 90.5563 25.3852L90.4763 25.4649L90.5563 25.3852C90.5563 25.4649 90.6363 25.4649 90.6363 25.5446C91.1163 26.2619 91.7563 26.8995 92.6363 27.3776C93.9163 28.2543 96.3163 29.2904 99.9163 29.2904C102.876 29.2904 105.356 28.5731 107.116 27.1385C108.876 25.704 109.836 23.6319 109.836 21.1613C109.996 16.3794 105.756 14.6261 101.276 13.4306Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.797 3.22949H83.0371C82.0771 3.22949 81.1172 3.78737 80.7172 4.66404L74.7974 16.9374L68.8777 4.66404C68.3977 3.78737 67.5177 3.22949 66.4778 3.22949H64.7179C63.1979 3.22949 61.918 4.50465 61.918 6.0189V26.262C61.918 28.2544 64.0779 29.7687 66.1578 28.5732C66.9578 28.1747 67.4377 27.2981 67.4377 26.4214V14.3871L72.3975 23.8711C72.8775 24.8274 73.8375 25.3056 74.7974 25.3056C75.7574 25.3056 76.7174 24.8274 77.1973 23.8711L82.1571 14.3871V26.4214C82.1571 27.2981 82.6371 28.1747 83.4371 28.5732C85.517 29.689 87.6769 28.1747 87.6769 26.262V6.0189C87.6769 4.50465 86.397 3.22949 84.797 3.22949Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1369_8540",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9065 9.39294) scale(15.3051 15.2478)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184049,
    stopColor: "#6F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3252,
    stopColor: "#910D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#A61519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5938,
    stopColor: "#BC1B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    stopColor: "#CB1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8762,
    stopColor: "#D52027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA2128"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1369_8540",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5386 18.5796) scale(13.6454 13.5938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0368098,
    stopColor: "#6F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3006,
    stopColor: "#910D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4172,
    stopColor: "#A01317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6776,
    stopColor: "#BE1B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8806,
    stopColor: "#D11F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA2128"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1369_8540",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7221 3.10028) scale(27.5474 27.4443)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3558,
    stopColor: "#DA2128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37021"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1369_8540",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.56135 27.5089) scale(14.2938 14.2397)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3129,
    stopColor: "#DA2128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7914,
    stopColor: "#910D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F0000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsbLogo);
export default __webpack_public_path__ + "static/media/msb-logo.c6d8abcde672a9633c30a2baeada159f.svg";
export { ForwardRef as ReactComponent };